<template>
  <div :class="'h-100 '+ (filtros.visible ? 'col-lg-10 p0' : 'col-lg-12')">
    <div :class="'card-body card-tabela ' + (filtros.visible ? '' : 'p0')">
      <div class="h-100">
        <div :class="'table-responsive records ' + classTableContainer || ''">
          <table class="table table-bordered table-hover mb-0 table-sm grid-table" v-if="result && result.Columns">
            <thead>
              <tr>
                <th class="checkbox-column">

                </th>
                <template v-for="(c) in result.Columns.filter(c => c.Display)">
                  <th
                      :class="c.Display"
                      :key="c.Display"
                      @click="handleOrdenar(c.Order)"
                      :title="c.Title">
                    <span>
                      {{c.Display}}
                    </span>
                    <span class="pull-right">
                      <i v-if="params.order == c.Order"
                         :class="'el ' + (params.direction == 'desc' ? 'el-chevron-down' : 'el-chevron-up')">

                      </i>
                    </span>
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item) in result.Records">
                <tr :key="item.Id"
                    @click="handleRowClickComMenu(item, $event)"
                    :title="typeof(title) === 'function' ? title(item) : title"
                    :class="(item === itemSelecionado ? 'active' : '')"
                    :data-id="item.Id">
                  <td>
                    <div :class="'checkbox-custom pull-right checkbox-'+ (typeof(checkboxClass) === 'function' ? checkboxClass(item) : checkboxClass)">
                      <input type="checkbox"
                             v-model="selected"
                             class="check-table"
                             :value="item.Id"
                             @change="($event) => $event.preventDefault()"
                             :id="'table' + item.Id">
                      <label :for="'table' + item.Id"></label>
                    </div>
                  </td>
                  <template v-for="(c) in result.Columns.filter(c => c.Display)">
                    <td :key="c.Property" :class="c.Property" :data-label="c.Display">
                      <span v-if="!c.Property.toLowerCase().includes('status')">{{item[c.Property]}}</span>
                      <span v-if="c.Property.toLowerCase().includes('status')" :class="'badge badge-'+(typeof(resolveStatusClass) === 'function' ? resolveStatusClass(item[c.Property]) : resolveStatusClass)">{{item[c.Property]}}</span>

                    </td>
                  </template>
                </tr>
              </template>

            </tbody>
            <tfoot>
              <slot name="tfoot"></slot>
            </tfoot>
          </table>
        </div>

        <row-action-menu v-if="selected && selected.length"
                          :open="menuVisivel"
                          :x="menuPos.x"
                          :y="menuPos.y"
                          :action-buttons="actionButtons"
                          :filter-class="filterClass"
                          @close="menuVisivel = false"></row-action-menu>

        <slot name="table2" :selected="selected" :result="result" :params="params">

        </slot>

        <pagination :pagination="result.Pagination"
                    :params="params"
                    :footerContent="footerContent"
                    @trocar-pagina="(page) => { handleConsultar(page) }">
        </pagination>

      </div>
    </div>
  </div>
</template>

<script>
import RowActionMenu from '@/components/RowActionMenu.vue';

export default {
    components: { RowActionMenu },
    data() {
        return {
            menus: [1, 2, 3, 4, 5, 6],
            menuVisivel: false,
            menuPos: { x: 0, y: 0 }
        }
    },
    props: {
        result: {},
        params: {},
        title: {},
        handleRowClick: {},
        checkboxClass: {},
        resolveStatusClass: {},
        handleOrdenar: {},
        itemSelecionado: {},
        selected: {},
        classTableContainer: {},
        filtros: {},
        footerContent: {},
        handleConsultar: {},
        actionButtons: { type: Array, default: () => [] },
        filterClass: { type: String, default: null }
    },
    methods: {

        clickHandler: function (emit, p, p2) {
            this.$emit(emit, p, p2);
        },
        // Clicar na linha continua rodando o pipeline existente de seleção
        // (handleRowClick -> changeCheckbox -> changeCheckboxCallback, que já recalcula
        // `.visible` de cada actionButton) antes de decidir se o menu deve aparecer.
        // Como a seleção é sempre única (no máx. 1 item), o mesmo clique que seleciona a
        // linha abre o menu, e clicar de novo na linha já selecionada (deselecionando) fecha.
        //
        // stopPropagation: sem isso, este MESMO clique (trocando de linha com o menu já
        // aberto de outra) também chega ao listener de "clique fora" do RowActionMenu (que
        // fica escutando em document enquanto o menu anterior está aberto) e fecha o menu
        // ao mesmo tempo em que este método pede pra abrir — os dois brigam pelo mesmo
        // clique. Clicar numa linha é sempre uma interação deliberada com o menu, nunca um
        // "clique fora" de verdade.
        handleRowClickComMenu: function (item, evt) {
            let jaSelecionado = this.selected && this.selected[0] === item.Id;
            this.handleRowClick(item);
            if (evt) {
                evt.stopPropagation();
                this.menuPos = { x: evt.clientX, y: evt.clientY };
            }
            this.$nextTick(() => {
                this.menuVisivel = !jaSelecionado;
            });
        }
    },
  };
</script>
